import React, { Component } from 'react'
import $ from 'jquery'
import * as Common from '../CommonControlls/CommonJs'
import MainLayout from '../CommonControlls/MainLayout'
import Topmenu from '../CommonControlls/Topmenubar'
import { connect } from 'react-redux'
import QRCode from 'qrcode.react'
import { SyncConfig } from '../OfflineDb/ConfigDataSync'
import ReactToPrint from 'react-to-print'
import DropDown from '../CommonControlls/DropdownRendrer'

const mapStateToProps = (store) => {
  return store
}

const mapDispatchToProps = (dispatch) => {
  return {
    ShowAlert: (Settings) => {
      dispatch({ type: 'UpdateAlert', payload: Settings })
    },
    ShowLoader: (Isloading) => {
      dispatch({ type: 'UpdateLoader', payload: Isloading })
    },
  }
}

class QRCode_Printing extends Component {
  constructor(props) {
    super(props)
    this.state = {
      QRIds: [],

      HCFTypelist: [
        { id: 1, name: 'BHU' },
        { id: 2, name: 'RHC' },
        { id: 3, name: 'Xpert Site' },
      ],
      HCFTypeId: 0,

      HCFLoader: false,
      BHUList: [],
      FilteredBHUList: [],
      BHUId: 0,

      RHCList: [],
      FilteredRHCList: [],
      RHCId: 0,

      ProvinceLoader: false,
      Provincelist: [],
      ProvinceId: 0,

      DistrictLoader: false,
      Districtlist: [],
      FilteredDistrictlist: [],
      DistrictId: 0,

      TehsilLoader: false,
      Tehsillist: [],
      FilteredTehsillist: [],
      TehsilId: 0,

      XpertSites: [],
      XpertSiteId: 0,

      ProcessedHCF: [],
      FacilityName: null,

      SubReciepents: [],
      SRId: 0,
      SRLoader: false,
    }
    this.componentRef = React.createRef()
  }

  HandleAutoSuggestValChange = (fieldId, value) => {
    this.setState({ [fieldId]: value }, () => {
      this.setState({ QRIds: [] })
      if (fieldId === 'ProvinceId') {
        var TempArr = this.state.Districtlist
        var filteredArr = TempArr.filter(function (obj) {
          return obj.provinceId === value
        })
        this.setState(
          {
            FilteredDistrictist: filteredArr,
          },
          () => {
            this.FilterOrganization()
          },
        )
      }
      if (fieldId === 'DistrictId') {
        var TempArr = this.state.Tehsillist
        var filteredArr = TempArr.filter(function (obj) {
          return obj.districtId === value
        })
        this.setState(
          {
            FilteredTehsillist: filteredArr,
          },
          () => {
            this.FilterOrganization()
          },
        )
      }
      if (fieldId === 'TehsilId') {
        // this.FilterOrganization()

        var TehsilId = this.state.TehsilId
        var BHUList = this.state.BHUList
        var RHCList = this.state.RHCList

        var filteredBHUList = BHUList.filter((obj) => {
          return obj.tehsilId === TehsilId
        })
        var filteredRHCList = RHCList.filter((obj) => {
          return obj.tehsilId === TehsilId
        })
        this.setState({
          FilteredBHUList: filteredBHUList,
          FilteredRHCList: filteredRHCList,
        })
      }
    })
  }
  FilterOrganization = () => {
    var ProvinceId = this.state.ProvinceId
    var DistrictId = this.state.DistrictId
    var TehsilId = this.state.TehsilId

    var BHUList = this.state.BHUList
    var RHCList = this.state.RHCList
    var XpertSiteList = this.state.XpertSites

    var filteredBHUList = BHUList.filter((obj) => {
      return (
        (ProvinceId === 0 || obj.provinceId === ProvinceId) &&
        (DistrictId === 0 || obj.districtId === DistrictId) &&
        (TehsilId === 0 || obj.tehsilId === TehsilId)
      )
    })
    var filteredRHCList = RHCList.filter((obj) => {
      return (
        (ProvinceId === 0 || obj.provinceId === ProvinceId) &&
        (DistrictId === 0 || obj.districtId === DistrictId) &&
        (TehsilId === 0 || obj.tehsilId === TehsilId)
      )
    })
    var filteredXpertSitesList = XpertSiteList.filter((obj) => {
      return (
        (ProvinceId === 0 || obj.provinceId === ProvinceId) &&
        (DistrictId === 0 || obj.districtId === DistrictId) &&
        (TehsilId === 0 || obj.tehsilId === TehsilId)
      )
    })
    this.setState({
      FilteredBHUList: filteredBHUList,
      FilteredRHCList: filteredRHCList,
      FilteredXpertSites: filteredXpertSitesList,
    })
  }

  render() {
    return (
      <div>
        <MainLayout />
        <div id="right-panel" class="right-panel">
          <Topmenu PageTitle="Generate QR Codes" isShowAddBtn={false} />
          <div class="content">
            <div class="card">
              <div class="card-body">
                <form onSubmit={this.SubmitForm} novalidate>
                  <div class="Table_Search row border-bottom-0">
                    <div class="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                      <label htmlFor="">Province</label>
                      <DropDown
                        multi={false}
                        dropdownRenderer={false}
                        create={false}
                        onChange={this.HandleAutoSuggestValChange}
                        Type="ProvinceId"
                        options={this.state.Provincelist}
                        val={this.state.ProvinceId}
                        addPlaceholder=""
                        disabled={false}
                        loading={this.state.ProvinceLoader}
                        searchBy="name"
                        labelField="name"
                        valueField="id"
                        contentRenderer={false}
                        placeholder="Select"
                      />
                    </div>

                    <div class="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                      <label for="">District</label>
                      <DropDown
                        multi={false}
                        dropdownRenderer={false}
                        create={false}
                        onChange={this.HandleAutoSuggestValChange}
                        Type="DistrictId"
                        options={this.state.FilteredDistrictist}
                        val={this.state.DistrictId}
                        addPlaceholder=""
                        disabled={false}
                        loading={this.state.DistrictLoader}
                        searchBy="name"
                        labelField="name"
                        valueField="id"
                        contentRenderer={false}
                        placeholder="Select"
                      />
                    </div>

                    <div class="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                      <label for="">Tehsil</label>
                      <DropDown
                        multi={false}
                        dropdownRenderer={false}
                        create={false}
                        onChange={this.HandleAutoSuggestValChange}
                        Type="TehsilId"
                        options={this.state.FilteredTehsillist}
                        val={this.state.TehsilId}
                        addPlaceholder=""
                        disabled={false}
                        loading={this.state.TehsilLoader}
                        searchBy="name"
                        labelField="name"
                        valueField="id"
                        contentRenderer={false}
                        placeholder="Select"
                      />
                    </div>

                    <div class="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                      <label for="">Type</label>
                      <DropDown
                        multi={false}
                        dropdownRenderer={false}
                        create={false}
                        onChange={this.HandleAutoSuggestValChange}
                        Type="HCFTypeId"
                        options={this.state.HCFTypelist}
                        val={this.state.HCFTypeId}
                        addPlaceholder=""
                        disabled={false}
                        loading={false}
                        searchBy="name"
                        labelField="name"
                        valueField="id"
                        contentRenderer={false}
                        placeholder="Select"
                      />
                    </div>

                    <div
                      class="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12"
                      hidden={this.state.HCFTypeId !== 1}
                    >
                      <label htmlFor="">
                        <span style={{ color: 'red' }}>* </span>BHU
                      </label>
                      <DropDown
                        multi={false}
                        dropdownRenderer={false}
                        create={false}

                        onChange={(fieldId, value) => {
                          this.setState({
                            FacilityName: this.state.FilteredBHUList.find(row => row.id === value)?.name
                          });
                          this.HandleAutoSuggestValChange(fieldId, value)
                        }}
                        Type="BHUId"
                        options={this.state.FilteredBHUList}
                        val={this.state.BHUId}
                        addPlaceholder=""
                        disabled={false}
                        loading={this.state.HCFLoader}
                        searchBy="name"
                        labelField="name"
                        valueField="id"
                        contentRenderer={false}
                        placeholder="Select"
                      />
                    </div>

                    <div
                      class="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12"
                      hidden={this.state.HCFTypeId !== 2}
                    >
                      <label htmlFor="">
                        <span style={{ color: 'red' }}>* </span>RHC
                      </label>
                      <DropDown
                        multi={false}
                        dropdownRenderer={false}
                        create={false}
                        onChange={(fieldId, value) => {
                          this.setState({
                            FacilityName: this.state.FilteredRHCList.find(row => row.id === value)?.name
                          });
                          this.HandleAutoSuggestValChange(fieldId, value)
                        }} Type="RHCId"
                        options={this.state.FilteredRHCList}
                        val={this.state.RHCId}
                        addPlaceholder=""
                        disabled={false}
                        loading={this.state.HCFLoader}
                        searchBy="name"
                        labelField="name"
                        valueField="id"
                        contentRenderer={false}
                        placeholder="Select"
                      />
                    </div>

                    <div
                      className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12"
                      hidden={this.state.HCFTypeId !== 3}
                    >
                      <label htmlFor="">
                        <span style={{ color: 'red' }}>* </span>Xpert Site
                      </label>
                      <DropDown
                        multi={false}
                        dropdownRenderer={false}
                        create={false}
                        onChange={(fieldId, value) => {
                          this.setState({
                            FacilityName: this.state.FilteredXpertSites.find(row => row.id === value)?.name
                          });
                          this.HandleAutoSuggestValChange(fieldId, value)
                        }} Type="XpertSiteId"
                        options={this.state.FilteredXpertSites}
                        val={this.state.XpertSiteId}
                        addPlaceholder=""
                        disabled={false}
                        loading={this.state.HCFLoader}
                        searchBy="name"
                        labelField="name"
                        valueField="id"
                        contentRenderer={false}
                        placeholder="Select"
                      />
                    </div>

                    <div class="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                      <label htmlFor="">
                        <span style={{ color: 'red' }}>* </span>Number Of Containers
                      </label>
                      <input
                        autocomplete="off"
                        type="number"
                        class="form-control Search_InputField"
                        id="NumberOfContainers"
                        placeholder="Enter number of containers"
                        required
                      />
                    </div>

                    <div class="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                      <button
                        style={{ position: 'relative', bottom: 0, marginTop: 35 }}
                        class="btn TopMenu_Addbtn"
                        type="submit"
                        id="Form_SaveBtn"
                      >
                        <i
                          style={{ color: 'white', marginRight: '5px' }}
                          class="fa fa-plus-circle"
                          aria-hidden="true"
                        ></i>
                        Generate
                      </button>
                    </div>
                  </div>
                </form>
                <div class="row">
                  <div
                    hidden={this.state.QRIds.length <= 0}
                    class="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12"
                  >
                    <ReactToPrint
                      bodyClass="ReactToPrint_Body"
                      documentTitle=""
                      trigger={() => {
                        return (
                          <span
                            style={{
                              cursor: 'pointer',
                              fontWeight: '700',
                            }}
                          >
                            Print
                          </span>
                        )
                      }}
                      content={() => this.componentRef.current}
                    />
                  </div>
                  <div
                    hidden={this.state.QRIds.length <= 0}
                    class="Animated_Scroll formInput_Container QRCodes_Container"
                    style={{ width: '100%' }}
                  >
                    <div ref={this.componentRef} class="row">
                      {this.state.QRIds.map((item, index) => {
                        return (
                          <div
                            class=""
                            style={{ padding: '30px', maxWidth: '150px' }}
                          >
                            <div
                              style={{
                                textAlign: 'center',
                                paddingBottom: '5px',
                                fontSize: '12px',
                              }}>
                              {this.state.FacilityName}
                            </div>
                            <QRCode value={item} size={90} renderAs="svg" />
                            <div
                              style={{
                                textAlign: 'center',
                                paddingBottom: '5px',
                                fontSize: '12px',
                                fontWeight: '700',
                                marginTop: '5px',
                              }}
                            >
                              {item}
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  componentWillMount() {
    if (this.props.UserAuthentication.AuthToken === '') {
      this.props.history.push('/Login')
    }
  }
  componentDidMount() {
    Common.AddClassToMenueLink('MenuLink_QRCodePrinting')
    this.GetPageConfigData(() => { })
    this.SelectSubReciepents()
    this.SelectXpertSites()
  }
  GetPageConfigData = (CallBack) => {
    this.props.ShowLoader({ Isloading: true })
    var d1 = $.Deferred()
    var d2 = $.Deferred()
    var d3 = $.Deferred()
    var d4 = $.Deferred()

    this.SelectHCF(() => {
      d1.resolve()
    })
    this.SelectProvinces(() => {
      d2.resolve()
    })
    this.SelectDistricts(() => {
      d3.resolve()
    })
    this.SelectTehsil(() => {
      d4.resolve()
    })
    $.when(d1, d2, d3, d4).done(() => {
      this.props.ShowLoader({ Isloading: false })
      CallBack()
    })
  }
  // SelectFacilityTypes = () => {
  //     Common.Ajax(this.props.UserAuthentication.AuthToken, 'GET', false, Common.BaseUrlAPI+"/api/HCF/SelectFacilityType", {}, (data) => {
  //         this.setState({
  //             HCFTypelist: data.data
  //         })
  //     }, (error) => {
  //         this.props.ShowAlert({Type: 0, Msg: error})
  //         setTimeout(function () {
  //             $("#Alertmsgbtn").click()
  //         }, 50);
  //     })
  // }
  SelectSubReciepents = () => {
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectALl_SubRecipient,
      {},
      (resp) => {
        if (resp.status) {
          this.setState({
            SubReciepents: resp.data.map((d) => ({
              id: d.id,
              name: d.short_name,
            })),
          })
        }
      },
    )
  }
  SelectHCF = (Callback) => {
    this.setState({ HCFLoader: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.GetAll_HCF,
      {
        fromDate: Common.ConvertToUtcDateTime(
          Common.getOnlyDate('01/01/2019') + ' 00:00:00',
        ),
        toDate: Common.ConvertToUtcDateTime(
          Common.getOnlyDate('01/01/2030') + ' 23:59:59',
        ),
      },
      (resp) => {
        var BHUList = []
        var RHCList = []

        for (var i = 0; i < resp.data.length; i++) {
          if (resp.data[i].typeId === 1) {
            BHUList.push(resp.data[i])
          } else {
            RHCList.push(resp.data[i])
          }
        }
        var ProcessedHCF = Common.ProcessDataInArray(resp.data, 'id')

        this.setState({
          BHUList: BHUList,
          // FilteredBHUList: BHUList,
          RHCList: RHCList,
          // FilteredRHCList: RHCList,
          HCFLoader: false,
          ProcessedHCF: ProcessedHCF,
        })
        Callback()
      },
      (error) => {
        this.setState({ HCFLoader: false })
        this.props.ShowAlert({ Type: 0, Msg: error })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
        Callback()
      },
    )
  }
  SelectProvinces = (Callback) => {
    this.setState({ ProvinceLoader: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectAll_Province,
      {},
      (data) => {
        this.setState({
          ProvinceLoader: false,
          Provincelist: data.data.sort(Common.compare),
        })
        Callback()
      },
      (error) => {
        this.setState({ ProvinceLoader: false })
        this.props.ShowAlert({ Type: 0, Msg: error })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
        Callback()
      },
    )
  }
  SelectXpertSites = () => {
    this.setState({ XpertSiteLoader: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectAll_XpertSites,
      {},
      (data) => {
        this.setState({
          XpertSiteLoader: false,
          XpertSites: data.data,
        })
      },
      (error) => {
        this.setState({ XpertSiteLoader: false })
        this.props.ShowAlert({ Type: 0, Msg: error })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }
  SelectDistricts = (Callback) => {
    this.setState({ DistrictLoader: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectAll_District,
      {},
      (data) => {
        this.setState({
          DistrictLoader: false,
          Districtlist: data.data.sort(Common.compare),
        })
        Callback()
      },
      (error) => {
        this.setState({ DistrictLoader: false })
        this.props.ShowAlert({ Type: 0, Msg: error })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
        Callback()
      },
    )
  }
  SelectTehsil = (Callback) => {
    this.setState({ TehsilLoader: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectAll_Tehsil,
      {},
      (data) => {
        this.setState({
          TehsilLoader: false,
          Tehsillist: data.data.sort(Common.compare),
        })
        Callback()
      },
      (error) => {
        this.setState({ TehsilLoader: false })
        this.props.ShowAlert({ Type: 0, Msg: error })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
        Callback()
      },
    )
  }
  SubmitForm = (e) => {
    e.preventDefault()

    if (
      (this.props.UserAuthentication?.UserInfo?.roleId == 1 ||
        this.props.UserAuthentication?.UserInfo?.roleId == 8) &&
      this.state.HCFTypeId == 1 &&
      this.state.BHUId == 0
    ) {
      this.props.ShowAlert({ Type: 1, Msg: 'Please select BHU' })
      setTimeout(() => {
        $('#Alertmsgbtn').click()
      }, 50)
      return
    }
    if (
      (this.props.UserAuthentication?.UserInfo?.roleId == 1 ||
        this.props.UserAuthentication?.UserInfo?.roleId == 8) &&
      this.state.HCFTypeId == 2 &&
      this.state.RHCId == 0
    ) {
      this.props.ShowAlert({ Type: 1, Msg: 'Please select RHC' })
      setTimeout(() => {
        $('#Alertmsgbtn').click()
      }, 50)
      return
    }
    if (Common.TryParseInt($('#NumberOfContainers').val()) < 1) {
      this.props.ShowAlert({
        Type: 1,
        Msg: 'Please enter valid number of containers',
      })
      setTimeout(() => {
        $('#Alertmsgbtn').click()
      }, 50)
      return
    }

    this.props.ShowLoader({ Isloading: true })
    var Parameters = {
      ContainersCount: Common.TryParseInt($('#NumberOfContainers').val()),

      roleId: this.props.UserAuthentication?.UserInfo?.roleId,
      hcfId: this.state.HCFTypeId === 1 ? this.state.BHUId : this.state.RHCId,

      srId: this.state.SRId,
      provinceId: this.state.ProvinceId,
      districtId: this.state.DistrictId,
      xpertSiteId: this.state.XpertSiteId,
      tehsilId: this.state.TehsilId,
    }
    if (this.state.XpertSiteId === 0) delete Parameters.xpertSiteId
    else delete Parameters.hcfId

    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'Get',
      false,
      this.state.XpertSiteId === 0
        ? Common.APILinks.InsertQRIds
        : Common.APILinks.InsertQRIdsXpert,
      Parameters,
      (resp) => {
        if (resp.status) {
          SyncConfig(
            () => {
              $('#NumberOfContainers').val('')
              this.setState({
                QRIds: resp.data,
              })
              this.props.ShowLoader({ Isloading: false })
            },
            () => {
              $('#NumberOfContainers').val('')
              this.setState({
                QRIds: resp.data,
              })
              this.props.ShowLoader({ Isloading: false })
              this.props.ShowAlert({
                Type: 0,
                Msg: 'Error in sync, please reload the page',
              })
              setTimeout(function () {
                $('#Alertmsgbtn').click()
              }, 50)
            },
          )
        } else {
          this.props.ShowLoader({ Isloading: false })
          this.props.ShowAlert({ Type: 0, Msg: resp.message })
          setTimeout(() => {
            $('#Alertmsgbtn').click()
          }, 50)
        }
      },
      (error) => {
        this.props.ShowLoader({ Isloading: false })
        this.props.ShowAlert({
          Type: 0,
          Msg: 'Something went wronge, please try again.',
        })
        setTimeout(() => {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(QRCode_Printing)
